import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { CurrencyInr, UsersThree } from '@phosphor-icons/react';
import { ModuleShell, ModuleSubnav } from '../../components/module-ui';
import PayrollPage from './PayrollPage';
import ClientEconomicsPage from './ClientEconomicsPage';

const SUBNAV = [
  { to: '/dashboard/payroll', label: 'Payroll / CTC', icon: CurrencyInr, end: true },
  { to: '/dashboard/payroll/clients', label: 'Client economics', icon: UsersThree },
];

export default function PayrollLayout() {
  return (
    <ModuleShell
      title="Accounts"
      subtitle="Monthly CTC, one-time client PO, and yearly recurring AMC"
      icon={CurrencyInr}
      subnav={<ModuleSubnav items={SUBNAV} aria-label="Accounts navigation" />}
    >
      <Routes>
        <Route index element={<PayrollPage />} />
        <Route path="clients" element={<ClientEconomicsPage />} />
        <Route path="*" element={<Navigate to="/dashboard/payroll" replace />} />
      </Routes>
    </ModuleShell>
  );
}
